import { createSlice } from "@reduxjs/toolkit";
import { getClicksData, getEnquiriesData, getContactsAccessedData } from "./thunk";

export const initialState = {
    clicksData: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        loading: false,
        error: null
    },
    enquiriesData: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        loading: false,
        error: null
    },
    contactsAccessedData: {
        data: [],
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        loading: false,
        error: null
    },
    activeTab: 'clicks'
};

const analyticsSlice = createSlice({
    name: "analytics",
    initialState,
    reducers: {
        setActiveTab: (state, action) => {
            state.activeTab = action.payload;
        },
        clearClicksData: (state) => {
            state.clicksData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
        },
        clearEnquiriesData: (state) => {
            state.enquiriesData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
        },
        clearContactsAccessedData: (state) => {
            state.contactsAccessedData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
        },
        resetAnalytics: (state) => {
            state.clicksData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
            state.enquiriesData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
            state.contactsAccessedData = {
                data: [],
                totalCount: 0,
                totalPages: 0,
                currentPage: 1,
                loading: false,
                error: null
            };
            state.activeTab = 'clicks';
        }
    },
    extraReducers: (builder) => {
        builder
            // Clicks data reducers
            .addCase(getClicksData.pending, (state) => {
                state.clicksData.loading = true;
                state.clicksData.error = null;
            })
            .addCase(getClicksData.fulfilled, (state, action) => {
                state.clicksData.loading = false;
                state.clicksData.data = action.payload?.data || [];
                state.clicksData.totalCount = action.payload?.total_count || 0;
                state.clicksData.totalPages = action.payload?.total_pages || 0;
                state.clicksData.currentPage = action.payload?.page || 1;
            })
            .addCase(getClicksData.rejected, (state, action) => {
                state.clicksData.loading = false;
                state.clicksData.error = action.payload?.message || 'Failed to fetch clicks data';
            })
            // Enquiries data reducers
            .addCase(getEnquiriesData.pending, (state) => {
                state.enquiriesData.loading = true;
                state.enquiriesData.error = null;
            })
            .addCase(getEnquiriesData.fulfilled, (state, action) => {
                state.enquiriesData.loading = false;
                state.enquiriesData.data = action.payload?.data || [];
                state.enquiriesData.totalCount = action.payload?.total_count || 0;
                state.enquiriesData.totalPages = action.payload?.total_pages || 0;
                state.enquiriesData.currentPage = action.payload?.page || 1;
            })
            .addCase(getEnquiriesData.rejected, (state, action) => {
                state.enquiriesData.loading = false;
                state.enquiriesData.error = action.payload?.message || 'Failed to fetch enquiries data';
            })
            // Contacts accessed data reducers
            .addCase(getContactsAccessedData.pending, (state) => {
                state.contactsAccessedData.loading = true;
                state.contactsAccessedData.error = null;
            })
            .addCase(getContactsAccessedData.fulfilled, (state, action) => {
                state.contactsAccessedData.loading = false;
                state.contactsAccessedData.data = action.payload?.data || [];
                state.contactsAccessedData.totalCount = action.payload?.total_count || 0;
                state.contactsAccessedData.totalPages = action.payload?.total_pages || 0;
                state.contactsAccessedData.currentPage = action.payload?.page || 1;
            })
            .addCase(getContactsAccessedData.rejected, (state, action) => {
                state.contactsAccessedData.loading = false;
                state.contactsAccessedData.error = action.payload?.message || 'Failed to fetch contacts accessed data';
            });
    },
});

export const { 
    setActiveTab, 
    clearClicksData, 
    clearEnquiriesData, 
    clearContactsAccessedData,
    resetAnalytics 
} = analyticsSlice.actions;

export default analyticsSlice.reducer;
